<div class="row">
  <div class="col-sm-12">
    <h2 class="text-primary mt-3">{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.LegalRepresentationIdentification.Title' | translate}}</h2>
  </div>
</div>

<div class="row">
  <!--Possui representante legal?-->
  <div class="col-sm-4">
    <div class="form-group">
      <fieldset [disabled]="!isServiceOrFunerary">
        <label for="hasLegalRepresentation" [class.disabled]="!isServiceOrFunerary || isNotStateRLDiferido()">
          <span class="mandatory" *ngIf="!(!isServiceOrFunerary || isNotStateRLDiferido())">*</span>{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.LegalRepresentationIdentification.Fields.HasLegalRepresentation' | translate}}
        </label>
        <div class="btn-group btn-group-toggle maxWidth">
          <label *ngFor="let domain of yesNo.slice().reverse()"
                 class="btn btn-toogle"
                 [class.active]="domain.value==cardData.hasLegalRepresentation?.toString()"
                 [radioLabel]="hasLegalRepresentation">
            <input type="radio"
                   [(ngModel)]="cardData.hasLegalRepresentation"
                   name="hasLegalRepresentation"
                   #hasLegalRepresentation="ngModel"
                   [value]="domain.value"
                   [required]="!(!isServiceOrFunerary || isNotStateRLDiferido())"
                   [clearRelated]="{model : this.cardData , propsToReset : ['representationType','legalRepresentationName']} ">
            {{domain.description}}
          </label>
          <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
        </div>
      </fieldset>
    </div>
  </div>

  <!--Nome do representante legal-->
  <div class="col-sm-8">
    <div class="form-group">
      <fieldset [disabled]="cardData.hasLegalRepresentation?.toString()!='true'  || isNotStateRLDiferido()">
        <label for="professionalSituation" [class.disabled]="cardData.hasLegalRepresentation?.toString()!='true'  || isStateRLDiferido()">
          <span *ngIf="!(cardData.hasLegalRepresentation?.toString()!='true'  || isStateRLDiferido())" class="mandatory">*</span>
          {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.LegalRepresentationIdentification.Fields.LegalRepresentationName' | translate}}
        </label>
        <input class="form-control"
               type="text"
               [(ngModel)]="cardData.legalRepresentationName"
               name="legalRepresentationName"
               #legalRepresentationName="ngModel"
               [disabled]="isStateRLDiferido()"
               maxlength="60"
               [required]="!(cardData.hasLegalRepresentation?.toString()!='true'  || isNotStateRLDiferido())">
        <validation-message [control]="legalRepresentationName"></validation-message>
      </fieldset>
    </div>
  </div>
</div>

<div class="row">
  <!--Tipologia de representação-->
  <div class="col-sm-4">
    <div class="form-group">
      <fieldset [disabled]="cardData.hasLegalRepresentation?.toString() != 'true'  || isNotStateRLDiferido()">
        <label for="scholarSituationDeathDate" [class.disabled]="cardData.hasLegalRepresentation?.toString() != 'true'  || isStateRLDiferido()">
          <span *ngIf="!(cardData.hasLegalRepresentation?.toString() != 'true'  || isStateRLDiferido())" class="mandatory">*</span>
          {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.LegalRepresentationIdentification.Fields.RepresentationType' | translate}}
        </label>
        <select class="custom-select"
                [(ngModel)]="cardData.representationType"
                name="representationType"
                #representationType="ngModel"
                [dropdownTitle]="{value : cardData.representationType, dimensions :  typesRepresentation }"
                nullableSelect
                [disabled]="isStateRLDiferido()"
                [required]="!(cardData.hasLegalRepresentation?.toString() != 'true'  || isNotStateRLDiferido())">
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of dropListRepresentationType" [value]="domain.value">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="representationType"></validation-message>
      </fieldset>
    </div>
  </div>

  <!--Estado da representação legal-->
  <div class="col-sm-8" *ngIf="cardData.stateRL != undefined && cardData.stateRL != null && cardData.stateRL > 0">
    <div class="form-group">
      <fieldset [disabled]="true">
        <label for="stateRL" [class.disabled]="true">
          <span *ngIf="false" class="mandatory">*</span>
          {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.LegalRepresentationIdentification.Fields.LegalRepresentationState' | translate}}
        </label>
        <input class="form-control" [value]="getEstadoRepresentacaoLegal()" readonly />
        <span class=" invalid-feedback"></span>

      </fieldset>
    </div>
  </div>

  <!--<div class="col-sm-2">
    <div class="form-group">
      <span class="icon invalid-feedback"
            [style.color]="getColorRepresentacaoLegal()">
        <i style="font-size:32px;position:relative;top:-32px" class="icon-user"></i>
      </span>
    </div>

  </div>-->
</div>

<div class="row">
  <!--Motivo de rejeição da representação legal-->
  <div class="col-sm-12" *ngIf="cardData.rejectionReason != null && cardData.rejectionReason != undefined">
    <div class="form-group">
      <fieldset>
        <label for="rejectionReason" class="form-control-disabled">
          {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.LegalRepresentationIdentification.Fields.RejectionReason' | translate}}
        </label>
        <textarea class="form-control input-right form-control-disabled" rows="3" type="text" [(ngModel)]="cardData.rejectionReason"
                  [maxLength]="1024"
                  [rows]=" isStateRLIndeferido()?10:4"
                  readonly
                  #rejectionReason="ngModel" name="cardData.rejectionReason"
                  messageFieldType="string"></textarea>
        <validation-message [control]="rejectionReason"></validation-message>
      </fieldset>
    </div>
  </div>
</div>
